<p>dialog-add-new-order works!</p>
